import { HttpClient, HttpResponse, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { FileNode, TokenDescarga } from './FileNode.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class FileExplorerservice {

  private fileNodeURLPlantilla: string = urlJoin(environment.apiURL, 'plantillas')
  private fileNodeURLExpediente: string = urlJoin(environment.apiURL, 'carpetas')
  private fileNodeURLArchivos: string = urlJoin(environment.apiURL, 'archivos')

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getPlantillaCarpetas(id_plantilla: string, tipoExplorador: string): Observable<FileNode[]> {
    const newfileNodeURLExpediente = urlJoin(this.fileNodeURLExpediente + "/carpeta/", id_plantilla, tipoExplorador)
    return this.http.get<FileNode[]>(newfileNodeURLExpediente)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newPlantillaCarpeta(node: FileNode, tipoExplorador: string): Observable<any> {
    const newfileNodeURLPlantilla = urlJoin(this.fileNodeURLExpediente + "/" + tipoExplorador)
    //console.log("newPlantillaCarpeta",node)
    return this.http.post<FileNode>(newfileNodeURLPlantilla, node)
      .pipe(
        tap(() => {
          const newPlantillaCarpetaSuccessMessage: string = $localize `:@@newPlantillaCarpetaSuccessMessage:Nueva carpeta creada correctamente`;
          this.notificationsService.showSuccessNotification(newPlantillaCarpetaSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  renamePlantillaCarpeta(id_carpeta: string, node: FileNode, tipoExplorador: string): Observable<any> {
    const newfileNodeURLExpediente = urlJoin(this.fileNodeURLExpediente + "/" + id_carpeta + "/" + tipoExplorador)
    //console.log("renamePlantillaCarpeta",node)
    return this.http.put<FileNode>(newfileNodeURLExpediente, node)
      .pipe(
        tap(() => {
          const renamePlantillaCarpetaSuccessMessage: string = $localize `:@@renamePlantillaCarpetaSuccessMessage:Carpeta renombrada correctamente`;
          this.notificationsService.showSuccessNotification(renamePlantillaCarpetaSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  renameFile(id_archivo: string, nuevoNombreSinExtension: string): Observable<any> {
    const renameFileURL = urlJoin(this.fileNodeURLArchivos, 'renombrar', id_archivo);
    console.log("renameFileURL", renameFileURL)
    return this.http.put(renameFileURL, { nuevoNombreSinExtension })
      .pipe(
        tap(() => {
          const renameFileSuccessMessage: string = $localize`:@@renameFileSuccessMessage:Archivo renombrado correctamente`;
          this.notificationsService.showSuccessNotification(renameFileSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }

  changePermissionsPlantillaCarpeta(id_carpeta: string, node: FileNode, tipoExplorador: string): Observable<any> {
    const newfileNodeURLExpediente = urlJoin(this.fileNodeURLExpediente + "/" + id_carpeta + "/" + tipoExplorador)
    //console.log("changePermissionsPlantillaCarpeta",node)
    return this.http.put<FileNode>(newfileNodeURLExpediente, node)
      .pipe(
        tap(() => {
          // Código adicional si es necesario
          const changePermissionsPlantillaCarpetaSuccessMessage: string = $localize `:@@changePermissionsPlantillaCarpetaSuccessMessage:Tipo cambiado correctamente`;
          this.notificationsService.showSuccessNotification(changePermissionsPlantillaCarpetaSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }



  deletePlantillaCarpeta(id_carpeta: string, tipoExplorador: string): Observable<any> {
    const newfileNodeURLExpediente = urlJoin(this.fileNodeURLExpediente + "/" + id_carpeta + "/" + tipoExplorador)
    //console.log("deletePlantillaCarpeta",id_carpeta)
    return this.http.delete<FileNode>(newfileNodeURLExpediente)
      .pipe(
        tap(() => {
          const deletePlantillaCarpetaSuccessMessage: string = $localize `:@@deletePlantillaCarpetaSuccessMessage:Carpeta eliminada correctamente`;
          this.notificationsService.showSuccessNotification(deletePlantillaCarpetaSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  uploadFiles(files: File[], id_carpeta: string, usuario_subida: string): Observable<any> {
    const newfileNodeURLArchivos = urlJoin(this.fileNodeURLArchivos, "subir?ngsw-bypass=true");

    const formData = new FormData();
    formData.append('id_carpeta', id_carpeta);
    formData.append('usuario_subida', usuario_subida);
    files.forEach(file => {
      formData.append('files[]', file, file.name); // Ajustado para enviar como un array
    });

    return this.http.post(newfileNodeURLArchivos, formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map((event: any) => {
        if (event instanceof HttpResponse) {
          const response = event.body;

          // Caso de respuesta 207 - siempre se recibe este status
          return {
            archivosCreados: response.archivosCreados || [],
            errores: response.errores || []
          };
        }
        return event;
      }),
      catchError(error => {
        this.notificationsService.showErrorNotification(error);
        return throwError(() => error);
      })
    );
  }



  downloadFile(id: string): Observable<Blob> {
    const downloadFileURL = urlJoin(this.fileNodeURLArchivos, id);

    return this.http.get(downloadFileURL, { responseType: 'blob' }).pipe(
      tap(() => {
        // Puedes añadir más lógica aquí si es necesario
      }),
      catchError(error => {
        this.notificationsService.showErrorNotification(error);
        return throwError(() => error);
      })
    );
  }

  deleteFile(id: string): Observable<any> {
    const deleteFileURL = urlJoin(this.fileNodeURLArchivos + "/" + id);
    return this.http.delete(deleteFileURL)
      .pipe(
        tap(() => {
          const deleteFileSuccessMessage: string = $localize `:@@deleteFileSuccessMessage:Archivo eliminado correctamente`;
          this.notificationsService.showSuccessNotification(deleteFileSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  downloadZip(id: string): Observable<HttpResponse<Blob>> {
    const downloadZipURL = urlJoin(this.fileNodeURLExpediente + "/download-zip/" + id + "/expediente/");

    return this.http.get(downloadZipURL, { observe: 'response', responseType: 'blob' }).pipe(
      tap(() => {
        // Puedes añadir más lógica aquí si es necesario
      }),
      catchError(error => {
        this.notificationsService.showErrorNotification(error);
        return throwError(() => error);
      })
    );
  }

  getTokenDescarga(id_archivo: string): Observable<TokenDescarga> {
    const newTokenDescarga = urlJoin(this.fileNodeURLArchivos + "/generar-url-descarga/", id_archivo)
    //console.log("newTokenDescarga", newTokenDescarga)
    return this.http.get<TokenDescarga>(newTokenDescarga)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getTokenDescargaZip(id_expediente: string): Observable<TokenDescarga> {
    const newTokenDescarga = urlJoin(this.fileNodeURLExpediente + "/generar-token-descarga-zip/", id_expediente, "/expediente")
    //console.log("newTokenDescarga", newTokenDescarga)
    return this.http.get<TokenDescarga>(newTokenDescarga)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  downloadFileAsBlob(downloadUrl: string): Observable<Blob> {
    return this.http.get(downloadUrl, { responseType: 'blob' }).pipe(
      catchError(error => {
        this.notificationsService.showErrorNotification(error);
        return throwError(() => error);
      })
    );
  }

  // Servicio para descargar un archivo para previsualización
  downloadFileForPreview(id: string): Observable<Blob> {
    const downloadFileURL = urlJoin(this.fileNodeURLArchivos, id);

    // Devuelve el archivo como Blob para previsualización
    return this.http.get(downloadFileURL, { responseType: 'blob' }).pipe(
      catchError((error) => {
        this.notificationsService.showErrorNotification(error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Mueve un archivo a una nueva carpeta.
   * @param id_archivo El ID del archivo a mover.
   * @param id_nueva_carpeta El ID de la carpeta de destino.
   * @returns Un observable con la respuesta.
   */
  moveFile(id_archivo: string, id_nueva_carpeta: string): Observable<any> {
    const moveFileURL = urlJoin(this.fileNodeURLArchivos, 'mover', id_archivo);
    // El cuerpo de la petición ahora es un objeto con la clave "idCarpetaDestino"
    const body = { idCarpetaDestino: id_nueva_carpeta };

    return this.http.put(moveFileURL, body)
      .pipe(
        tap(() => {
          const moveFileSuccessMessage: string = $localize`:@@moveFileSuccessMessage:Archivo movido correctamente`;
          this.notificationsService.showSuccessNotification(moveFileSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }






}